export class UserAgent {
  static version = "1.0.0";
  navigator = typeof window.navigator !== "undefined" ? window.navigator : {};
  userAgent = window.navigator.userAgent || "";
  constants = {
    engine: ["WebKit", "Trident", "Gecko", "Presto"],
    browser: [
      "Safari",
      "Chrome",
      "Edge",
      "IE",
      "Firefox",
      "Firefox Focus",
      "Chromium",
      "Opera",
      "Vivaldi",
      "Yandex",
      "Arora",
      "Lunascape",
      "QupZilla",
      "Coc Coc",
      "Kindle",
      "Iceweasel",
      "Konqueror",
      "Iceape",
      "SeaMonkey",
      "Epiphany",
      "360",
      "360SE",
      "360EE",
      "UC",
      "QQBrowser",
      "QQ",
      "Baidu",
      "Maxthon",
      "Sogou",
      "LBBROWSER",
      "2345Explorer",
      "TheWorld",
      "XiaoMi",
      "Quark",
      "Qiyu",
      "Wechat",
      "Taobao",
      "Alipay",
      "Weibo",
      "Douban",
      "Suning",
      "iQiYi",
      "DingTalk",
      "EMobile"
    ],
    os: [
      "Windows",
      "Linux",
      "Mac OS",
      "Android",
      "Ubuntu",
      "FreeBSD",
      "Debian",
      "iOS",
      "Windows Phone",
      "BlackBerry",
      "MeeGo",
      "Symbian",
      "Chrome OS",
      "WebOS"
    ],
    device: ["Mobile", "Tablet"]
  };
  device = "PC";
  engine = "";
  browser = "";
  os = "";

  constructor(userAgent) {
    if (userAgent) {
      this.userAgent = userAgent;
    }
    this.init();
  }

  get language() {
    const g = this.navigator.browserLanguage || this.navigator.language;
    const arr = g.split("-");
    if (arr[1]) {
      arr[1] = arr[1].toUpperCase();
    }
    return arr.join("_");
  }

  get version() {
    const u = this.userAgent;
    const map = {
      Safari: () => {
        return u.replace(/^.*Version\/([\d.]+).*$/, "$1");
      },
      Chrome: () => {
        return u
          .replace(/^.*Chrome\/([\d.]+).*$/, "$1")
          .replace(/^.*CriOS\/([\d.]+).*$/, "$1");
      },
      IE: () => {
        return u
          .replace(/^.*MSIE ([\d.]+).*$/, "$1")
          .replace(/^.*rv:([\d.]+).*$/, "$1");
      },
      Edge: () => {
        return u.replace(/^.*Edge\/([\d.]+).*$/, "$1");
      },
      Firefox: () => {
        return u
          .replace(/^.*Firefox\/([\d.]+).*$/, "$1")
          .replace(/^.*FxiOS\/([\d.]+).*$/, "$1");
      },
      "Firefox Focus": () => {
        return u.replace(/^.*Focus\/([\d.]+).*$/, "$1");
      },
      Chromium: () => {
        return u.replace(/^.*Chromium\/([\d.]+).*$/, "$1");
      },
      Opera: () => {
        return u
          .replace(/^.*Opera\/([\d.]+).*$/, "$1")
          .replace(/^.*OPR\/([\d.]+).*$/, "$1");
      },
      Vivaldi: () => {
        return u.replace(/^.*Vivaldi\/([\d.]+).*$/, "$1");
      },
      Yandex: () => {
        return u.replace(/^.*YaBrowser\/([\d.]+).*$/, "$1");
      },
      Arora: () => {
        return u.replace(/^.*Arora\/([\d.]+).*$/, "$1");
      },
      Lunascape: () => {
        return u.replace(/^.*Lunascape[/\s]([\d.]+).*$/, "$1");
      },
      QupZilla: () => {
        return u.replace(/^.*QupZilla[/\s]([\d.]+).*$/, "$1");
      },
      "Coc Coc": () => {
        return u.replace(/^.*coc_coc_browser\/([\d.]+).*$/, "$1");
      },
      Kindle: () => {
        return u.replace(/^.*Version\/([\d.]+).*$/, "$1");
      },
      Iceweasel: () => {
        return u.replace(/^.*Iceweasel\/([\d.]+).*$/, "$1");
      },
      Konqueror: () => {
        return u.replace(/^.*Konqueror\/([\d.]+).*$/, "$1");
      },
      Iceape: () => {
        return u.replace(/^.*Iceape\/([\d.]+).*$/, "$1");
      },
      SeaMonkey: () => {
        return u.replace(/^.*SeaMonkey\/([\d.]+).*$/, "$1");
      },
      Epiphany: () => {
        return u.replace(/^.*Epiphany\/([\d.]+).*$/, "$1");
      },
      "360": () => {
        return u.replace(/^.*QihooBrowser\/([\d.]+).*$/, "$1");
      },
      "360SE": () => {
        const hash = {
          "63": "10.0",
          "55": "9.1",
          "45": "8.1",
          "42": "8.0",
          "31": "7.0",
          "21": "6.3"
        };
        const chromeVision = u.replace(/^.*Chrome\/([\d]+).*$/, "$1");
        return hash[chromeVision] || "";
      },
      "360EE": () => {
        const hash = {
          "69": "11.0",
          "63": "9.5",
          "55": "9.0",
          "50": "8.7",
          "30": "7.5"
        };
        const chromeVision = u.replace(/^.*Chrome\/([\d]+).*$/, "$1");
        return hash[chromeVision] || "";
      },
      Maxthon: () => {
        return u.replace(/^.*Maxthon\/([\d.]+).*$/, "$1");
      },
      QQBrowser: () => {
        return u.replace(/^.*QQBrowser\/([\d.]+).*$/, "$1");
      },
      QQ: () => {
        return u.replace(/^.*QQ\/([\d.]+).*$/, "$1");
      },
      Baidu: () => {
        return u.replace(/^.*BIDUBrowser[\s/]([\d.]+).*$/, "$1");
      },
      UC: () => {
        return u.replace(/^.*UC?Browser\/([\d.]+).*$/, "$1");
      },
      Sogou: () => {
        return u
          .replace(/^.*SE ([\d.X]+).*$/, "$1")
          .replace(/^.*SogouMobileBrowser\/([\d.]+).*$/, "$1");
      },
      LBBROWSER: () => {
        const hash = {
          "57": "6.5",
          "49": "6.0",
          "46": "5.9",
          "42": "5.3",
          "39": "5.2",
          "34": "5.0",
          "29": "4.5",
          "21": "4.0"
        };
        const chromeVision = window.navigator.userAgent.replace(
          /^.*Chrome\/([\d]+).*$/,
          "$1"
        );
        return hash[chromeVision] || "";
      },
      "2345Explorer": () => {
        return u.replace(/^.*2345Explorer\/([\d.]+).*$/, "$1");
      },
      TheWorld: () => {
        return u.replace(/^.*TheWorld ([\d.]+).*$/, "$1");
      },
      XiaoMi: () => {
        return u.replace(/^.*MiuiBrowser\/([\d.]+).*$/, "$1");
      },
      Quark: () => {
        return u.replace(/^.*Quark\/([\d.]+).*$/, "$1");
      },
      Qiyu: () => {
        return u.replace(/^.*Qiyu\/([\d.]+).*$/, "$1");
      },
      Wechat: () => {
        return u.replace(/^.*MicroMessenger\/([\d.]+).*$/, "$1");
      },
      DingTalk: () => {
        return u.replace(/^.*AliApp\(DingTalk\/([\d.]+).*$/, "$1");
      },
      EMobile: () => {
        return u.replace(/^.*E-Mobile\d+\/([\d.]+).*$/, "$1");
      },
      Taobao: () => {
        return u.replace(/^.*AliApp\(TB\/([\d.]+).*$/, "$1");
      },
      Alipay: () => {
        return u.replace(/^.*AliApp\(AP\/([\d.]+).*$/, "$1");
      },
      Weibo: () => {
        return u.replace(/^.*weibo__([\d.]+).*$/, "$1");
      },
      Douban: () => {
        return u.replace(/^.*com.douban.frodo\/([\d.]+).*$/, "$1");
      },
      Suning: () => {
        return u.replace(/^.*SNEBUY-APP([\d.]+).*$/, "$1");
      },
      iQiYi: () => {
        return u.replace(/^.*IqiyiVersion\/([\d.]+).*$/, "$1");
      }
    };
    const fn = map[this.browser];
    let version = "";
    if (typeof fn === "function") {
      version = fn();
    }
    return version === u ? "" : version;
  }

  get osVersion() {
    const u = this.userAgent;
    const map = {
      Windows: () => {
        const v = u.replace(/^.*Windows NT ([\d.]+);.*$/, "$1");
        const hash = {
          "6.4": "10",
          "6.3": "8.1",
          "6.2": "8",
          "6.1": "7",
          "6.0": "Vista",
          "5.2": "XP",
          "5.1": "XP",
          "5.0": "2000"
        };
        return hash[v] || v;
      },
      Android: () => {
        return u.replace(/^.*Android ([\d.]+);.*$/, "$1");
      },
      iOS: () => {
        return u.replace(/^.*OS ([\d_]+) like.*$/, "$1").replace(/_/g, ".");
      },
      Debian: () => {
        return u.replace(/^.*Debian\/([\d.]+).*$/, "$1");
      },
      "Windows Phone": () => {
        return u.replace(/^.*Windows Phone( OS)? ([\d.]+);.*$/, "$2");
      },
      "Mac OS": () => {
        return u.replace(/^.*Mac OS X ([\d_]+).*$/, "$1").replace(/_/g, ".");
      },
      WebOS: () => {
        return u.replace(/^.*hpwOS\/([\d.]+);.*$/, "$1");
      }
    };
    const fn = map[this.os];
    let osVersion = "";
    if (typeof fn === "function") {
      osVersion = fn();
    }
    return osVersion === u ? "" : osVersion;
  }

  init = () => {
    Object.keys(this.constants).forEach(key => {
      this.constants[key].forEach(constant => {
        if (this.match()[constant]) {
          this[key] = constant;
        }
      });
    });
    if (this.browser === "Edge") {
      this.engine = "EdgeHTML";
    } else if (this.browser === "Chrome" && parseInt(this.version, 10) > 27) {
      this.engine = "Blink";
    } else if (this.browser === "Opera" && parseInt(this.version, 10) > 12) {
      this.engine = "Blink";
    } else if (this.browser === "Yandex") {
      this.engine = "Blink";
    }
  };

  mime = (option, value) => {
    const mimeTypes = this.navigator.mimeTypes;
    for (const mt in mimeTypes) {
      if (mimeTypes[mt][option] === value) {
        return true;
      }
    }
    return false;
  };

  match = () => {
    const u = this.userAgent;
    const m = {
      // engine
      Trident: u.indexOf("Trident") > -1 || u.indexOf("NET CLR") > -1,
      Presto: u.indexOf("Presto") > -1,
      WebKit: u.indexOf("AppleWebKit") > -1,
      Gecko: u.indexOf("Gecko/") > -1,
      // browser
      Safari: u.indexOf("Safari") > -1,
      Chrome: u.indexOf("Chrome") > -1 || u.indexOf("CriOS") > -1,
      IE: u.indexOf("MSIE") > -1 || u.indexOf("Trident") > -1,
      Edge: u.indexOf("Edge") > -1,
      Firefox: u.indexOf("Firefox") > -1 || u.indexOf("FxiOS") > -1,
      "Firefox Focus": u.indexOf("Focus") > -1,
      Chromium: u.indexOf("Chromium") > -1,
      Opera: u.indexOf("Opera") > -1 || u.indexOf("OPR") > -1,
      Vivaldi: u.indexOf("Vivaldi") > -1,
      Yandex: u.indexOf("YaBrowser") > -1,
      Arora: u.indexOf("Arora") > -1,
      Lunascape: u.indexOf("Lunascape") > -1,
      QupZilla: u.indexOf("QupZilla") > -1,
      "Coc Coc": u.indexOf("coc_coc_browser") > -1,
      Kindle: u.indexOf("Kindle") > -1 || u.indexOf("Silk/") > -1,
      Iceweasel: u.indexOf("Iceweasel") > -1,
      Konqueror: u.indexOf("Konqueror") > -1,
      Iceape: u.indexOf("Iceape") > -1,
      SeaMonkey: u.indexOf("SeaMonkey") > -1,
      Epiphany: u.indexOf("Epiphany") > -1,
      "360": u.indexOf("QihooBrowser") > -1 || u.indexOf("QHBrowser") > -1,
      "360EE": u.indexOf("360EE") > -1,
      "360SE": u.indexOf("360SE") > -1,
      UC: u.indexOf("UC") > -1 || u.indexOf(" UBrowser") > -1,
      QQBrowser: u.indexOf("QQBrowser") > -1,
      QQ: u.indexOf("QQ/") > -1,
      Baidu: u.indexOf("Baidu") > -1 || u.indexOf("BIDUBrowser") > -1,
      Maxthon: u.indexOf("Maxthon") > -1,
      Sogou: u.indexOf("MetaSr") > -1 || u.indexOf("Sogou") > -1,
      LBBROWSER: u.indexOf("LBBROWSER") > -1,
      "2345Explorer": u.indexOf("2345Explorer") > -1,
      TheWorld: u.indexOf("TheWorld") > -1,
      XiaoMi: u.indexOf("MiuiBrowser") > -1,
      Quark: u.indexOf("Quark") > -1,
      Qiyu: u.indexOf("Qiyu") > -1,
      Taobao: u.indexOf("AliApp(TB") > -1,
      Alipay: u.indexOf("AliApp(AP") > -1,
      Wechat: u.indexOf("MicroMessenger") > -1,
      DingTalk: u.indexOf("AliApp(DingTalk") > -1,
      EMobile: u.indexOf("E-Mobile") > -1,
      Weibo: u.indexOf("Weibo") > -1,
      Douban: u.indexOf("com.douban.frodo") > -1,
      Suning: u.indexOf("SNEBUY-APP") > -1,
      iQiYi: u.indexOf("IqiyiApp") > -1,
      // os
      Windows: u.indexOf("Windows") > -1,
      Linux: u.indexOf("Linux") > -1 || u.indexOf("X11") > -1,
      "Mac OS": u.indexOf("Macintosh") > -1,
      Android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1,
      Ubuntu: u.indexOf("Ubuntu") > -1,
      FreeBSD: u.indexOf("FreeBSD") > -1,
      Debian: u.indexOf("Debian") > -1,
      "Windows Phone":
        u.indexOf("IEMobile") > -1 || u.indexOf("Windows Phone") > -1,
      BlackBerry: u.indexOf("BlackBerry") > -1 || u.indexOf("RIM") > -1,
      MeeGo: u.indexOf("MeeGo") > -1,
      Symbian: u.indexOf("Symbian") > -1,
      iOS: u.indexOf("like Mac OS X") > -1,
      "Chrome OS": u.indexOf("CrOS") > -1,
      WebOS: u.indexOf("hpwOS") > -1,
      // device
      Mobile:
        u.indexOf("Mobi") > -1 ||
        u.indexOf("iPh") > -1 ||
        u.indexOf("480") > -1,
      Tablet:
        u.indexOf("Tablet") > -1 ||
        u.indexOf("Pad") > -1 ||
        u.indexOf("Nexus 7") > -1
    };
    let is360 = false;
    if (window.chrome) {
      const chromeVision = Number(u.replace(/^.*Chrome\/([\d]+).*$/, "$1"));
      if (chromeVision > 36 && window.showModalDialog) {
        is360 = true;
      } else if (chromeVision > 45) {
        is360 = this.mime("type", "application/vnd.chromium.remoting-viewer");
      }
    }
    if (m.Mobile) {
      m.Mobile = !(u.indexOf("iPad") > -1);
    } else if (is360) {
      if (this.mime("type", "application/gameplugin")) {
        m["360SE"] = true;
      } else if (
        this.navigator &&
        (this.navigator.connection &&
          typeof this.navigator.connection.saveData === "undefined")
      ) {
        m["360SE"] = true;
      } else {
        m["360EE"] = true;
      }
    }
    if (m.IE || m.Edge) {
      const navigatorTop = window.screenTop - window.screenY;
      switch (navigatorTop) {
        case 71: // 无收藏栏,贴边
        case 99: // 有收藏栏,贴边
        case 102: // 有收藏栏,非贴边
          m["360EE"] = true;
          break;
        case 75: // 无收藏栏,贴边
        case 74: // 无收藏栏,非贴边
        case 105: // 有收藏栏,贴边
        case 104: // 有收藏栏,非贴边
          m["360SE"] = true;
          break;
        default:
          break;
      }
    }
    if (m.Baidu && m.Opera) {
      m.Baidu = false;
    }
    return m;
  };
}

const uaa = new UserAgent();

export const ua = {
  device: uaa.device,
  engine: uaa.engine,
  browser: uaa.browser,
  os: uaa.os,
  osVersion: uaa.osVersion,
  version: uaa.version,
  language: uaa.language
};

window.ua = ua;



// WEBPACK FOOTER //
// ./ecology9/wea-tools/userAgent.js